import React, { useState } from "react";
import DataTable from "react-data-table-component";
import { Toaster } from "react-hot-toast";

interface GroupData {
  groupId: number;
  groupName: string;
  isActive: boolean;
  tenantId: number;
}

interface ViewGroupsCardProps {
  groupsData: GroupData[];
  onEditGroup: (group: GroupData) => void;
  onAddClick: () => void;
  showAddButton: boolean;
}

const ViewGroupsCard: React.FC<ViewGroupsCardProps> = ({
  groupsData,
  onEditGroup,
  onAddClick,
  showAddButton,
}) => {
  const [toggleCleared, setToggleCleared] = useState(false);

  // Handle row selection
  const handleRowSelected = (state: any) => {
    console.log("Selected rows:", state.selectedRows);
  };

  // Define columns for DataTable
  const columns = [
    {
      name: "Group Name",
      selector: (row: GroupData) => row.groupName,
      sortable: true,
      cell: (row: GroupData) => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: "rgb(167 133 144)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "10px",
              fontWeight: "bold",
            }}
          >
            {row.groupName.charAt(0).toUpperCase()}
          </div>
          <span style={{ fontWeight: "500", color: "#33475b" }}>
            {row.groupName}
          </span>
        </div>
      ),
      width: "350px",
    },
    {
      name: "Status",
      selector: (row: GroupData) => row.isActive,
      sortable: true,
      cell: (row: GroupData) => {
        const isActive =
          typeof row.isActive === "boolean"
            ? row.isActive
            : row.isActive === "true";
        return (
          <span className={isActive ? "active-status" : "inactive-status"}>
            {isActive ? "ACTIVE" : "INACTIVE"}
          </span>
        );
      },
      width: "350px",
    },
    {
      name: "",
      cell: (row: GroupData) => (
        <div className="action-cell">
          <button
            className="action-button edit-button"
            title="Edit Group"
            onClick={() => onEditGroup(row)}
          >
            <i className="bi bi-pencil-square"></i>
          </button>
          <button className="action-button more-button" title="Replace icon">
            <i className="bi bi-three-dots"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "60px",
      className: "sticky-action-column",
    },
  ];

  return (
    <div className="card">
      <div>
        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="card-header carHeaderWithBtn d-flex justify-content-between align-items-center">
        <h5 className="card-title mb-0">Groups List</h5>
        {showAddButton && (
          <button
            type="button"
            className="demo-btn btn btn-outline-primary btn-sm"
            onClick={onAddClick}
          >
            <i className="fas fa-plus me-1"></i>+ Add Group
          </button>
        )}
      </div>
      <div className="card-body p-0">
        <DataTable
          columns={columns}
          data={groupsData}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[5, 10, 15, 20]}
          highlightOnHover
          striped
          responsive
          noDataComponent={
            <div className="text-center py-4">
              <p className="text-muted mb-0">No groups found.</p>
            </div>
          }
          selectableRows
          selectableRowsComponentProps={{
            className: "custom-checkbox",
          }}
          onSelectedRowsChange={handleRowSelected}
          clearSelectedRows={toggleCleared}
          fixedHeader
          fixedHeaderScrollHeight="400px"
        />
      </div>
    </div>
  );
};

export default ViewGroupsCard;
